import { createSlice, PayloadAction } from '@reduxjs/toolkit';

//Interface for the Loader state
interface LoaderInitialState {
  isLoading: boolean;
}

const initialState = {
  isLoading: false
} as LoaderInitialState;

/**
 * Loader Reducer with the toggling the loader functionality.
 * When calling the toggleLoading() function it will render
 * the loader component based on the prop inherited in the component
 */
const loaderReducer = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    toggleLoading(state: LoaderInitialState, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    }
  }
});

export const { toggleLoading } = loaderReducer.actions;
export default loaderReducer.reducer;
